<template>
  <a-layout class='index animated fadeIn'>
    <div class="s_bf">
      <a-form ref="ruleForm" :model="form" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
        <a-form-item ref="level" label="资质名称" name="level">
          <div class="s_flex_ali">
            <p class="s_c333 m-r-15">企业营业执照</p>
            <div class="s_flex_ali">
              <WarningOutlined v-if='status !== 1' class="fz-16 s_cd41" />
              <CheckOutlined v-else class="fz-16 s_c376" />
              <p>{{status_text}}</p>
            </div>
          </div>
        </a-form-item>
        <a-form-item ref="business_name" label="企业名称" name="business_name"  help='1、请完整填写在工商局注册的公司全称。2、公司名称通过审核后不可再修改。'>
          <a-input v-model:value="form.business_name" placeholder='请输入企业名称' :disabled='status == 1' />
        </a-form-item>
        <a-form-item ref="license_no" label="营业执照号码" name="license_no" :help='form.license_type == 1 ? "请输入15位营业执照注册号或18位的统一社会信用代码。":"请输入10-20位的营业执照号码，可支持英文、数字和“-”。"'>
          <a-input-group compact>
            <a-select style="width: 15%" v-model:value="form.license_type">
              <a-select-option value="1">中国</a-select-option>
              <a-select-option value="2">国外</a-select-option>
            </a-select>
            <a-input style="width: 85%" v-model:value="form.license_no" placeholder='营业执照号码' />
          </a-input-group>
        </a-form-item>
        <a-form-item ref="bar_code" label="组织机构代码" name="bar_code">
          <a-input v-model:value="form.bar_code" placeholder='请输入组织机构代码' />
        </a-form-item>
        <a-form-item ref="license_images" label="营业执照" name="license_images" help='请上传有效期内且年检章齐全的营业执照清晰彩色原件扫描件。图片大小不超过5M，支持jpg/png格式'>
          <material :groupType='1' :image="form.license_images" :max="1"
          v-on:handlechoose="(data)=>{form.license_images=data}" v-on:handledel="form.license_images=''" />
        </a-form-item>
        <a-form-item ref="business_addr" label="企业地址" name="business_addr">
          <a-input v-model:value="form.business_addr" placeholder='请输入企业地址' />
        </a-form-item>
        <a-form-item :wrapper-col="{ span: 8, offset: 4 }">
          <a-button type="primary" @click="onSubmit">
            提交审核
          </a-button>
        </a-form-item>
      </a-form>
    </div>
  </a-layout>
</template>
<script>
  import { WarningOutlined, CheckOutlined } from "@ant-design/icons-vue";
  import { ref, onMounted, reactive, toRefs, inject,watchEffect } from 'vue';
  import { message } from 'ant-design-vue';
  import { iscode } from "@/utils/app";
  // 初始化默认筛选项数值
  let defForm = {
    license_type: '1',
    business_name:'',
    business_addr: '',
    license_no: '',
    license_images: '',
    bar_code:''
  }
  export default {
    name:'licence',
    components: {WarningOutlined, CheckOutlined },
    props: {
      formData: {
        type: Object
      },
    },
    setup(props,{emit}) {
      //pass
      const form = ref({ ...defForm });
      const state = reactive({
        status:0,
        status_text:'未认证',
        labelCol: { span: 4 },
        wrapperCol: { span: 20 },
        rules: {
          business_name: [
            { required: true, message: '请输入企业名称'}
          ],
          license_no: [
            { required: true, message: '请输入营业执照号码'}
          ],
          license_images: [
            { required: true, message: '请上传营业执照'}
          ],
          business_addr:[
            {required: true, message: '请输入企业地址'}
          ],
        }
      });
      const ruleForm = ref()
      const _lodash = inject("_lodash");
      const onSubmit = () => {
        ruleForm.value.validate().then(() => {
          emit('onsubmit',form.value)
        }).catch(error => {
          message.error('请完善表单！');
        });
      }
      onMounted(() => {
      });
      
      watchEffect(() => {
        var formData = props.formData || {};
        if (!_lodash.isEmpty(formData.detail)) {
          form.value = formData.detail;
          state.status = formData.status
          state.status_text = formData.status_text
        } else {
          form.value = defForm;
          state.status = formData.status
          state.status_text = formData.status_text
        }
      });
      return {
        form,
        ...toRefs(state),
        ruleForm,
        onSubmit
      }
    }
  }
</script>
